import React, { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { ItemCategory } from '../../../app/models/ItemCategory';
import useItemCategoryService from '../../../app/services/hooks/useItemCategoryService';
import ItemCategoryForm from './forms/ItemCategoryForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ItemCategoryCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [errorGetData, setErrorGetData] = useState('');
    const [category, setCategory] = useState<ItemCategory>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();
    const { fetchingStoreCategory, storeCategory } = useItemCategoryService();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando categoría...');
        storeCategory(category, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <ItemCategoryForm
                        categoryDataForm={category}
                        setCategoryDataForm={setCategory}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreCategory} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreCategory} />
                </div>
            </div>
        </>
    );
};

export default ItemCategoryCreate;
